// extracted by mini-css-extract-plugin
module.exports = {"header":"Sidebar_header__sgdt7"};